import React from 'react';
import { motion, Variants } from 'framer-motion';
import { useLandingTranslations } from '../contexts/LandingTranslationContext';

const fadeInUp: Variants = {
  hidden: { opacity: 0, y: 60 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut" as const
    }
  }
};

const FAQ = () => {
  const { translations } = useLandingTranslations();

  return (
    <motion.section className="py-20 bg-[#F8F9FA]">
      <div className="container mx-auto px-8">
        <motion.h2 
          className="text-4xl font-bold text-center text-[#3D587D] mb-16"
          variants={fadeInUp}
          initial="hidden"
          whileInView="visible"
        >
          {translations.faq.title}
        </motion.h2>
        <div className="max-w-3xl mx-auto space-y-6">
          {translations.faq.items.map((faq, index) => (
            <motion.div
              key={index}
              className="bg-white p-6 rounded-xl shadow-md"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              whileHover={{ scale: 1.02 }}
            >
              <h3 className="text-xl font-semibold text-[#3D587D] mb-2">{faq.question}</h3>
              <p className="text-[#407CBD]">{faq.answer}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.section>
  );
};

export default FAQ; 